import * as React from "react";
import { classNames } from "../uitk-react-utils/index.js";
import { UitkListItem } from "./index.js";
import {
  UitkListOrientations,
  UitkListSizes,
  UitkListTypes
} from "./types.js";
const UitkListContext = React.createContext({});
export default UitkListContext;
export function UitkList({
  bullet = "default",
  children,
  className,
  data,
  orientation = "stacked",
  size = 2,
  type = "unordered",
  spacing = true,
  ...attributes
}) {
  const baseClass = "uitk-typelist";
  const cssClassNames = classNames(
    baseClass,
    orientation && `${baseClass}-${UitkListOrientations.get(orientation)}`,
    size && `${baseClass}-${UitkListSizes.get(size)}`,
    spacing && `${baseClass}-spacing`,
    className
  );
  const Tag = type && UitkListTypes.get(type) || "ul";
  const dataChildren = data?.map((item, index) => /* @__PURE__ */ React.createElement(UitkListItem, { key: `listitem-${index}` }, !item.content ? item : null, item.icon ? item.icon : null, item.content ? item.content : null));
  return /* @__PURE__ */ React.createElement(Tag, { className: cssClassNames, ...attributes, role: "list" }, /* @__PURE__ */ React.createElement(UitkListContext.Provider, { value: { bullet, orientation, type, size } }, !data ? children : dataChildren));
}
;
UitkList.displayName = "UitkList";
